import { makeStyles } from 'tss-react/mui';

export const useImageOrVideoMessageStyles = makeStyles()({
  button: {
    width: '100%',
    height: '100%',
    borderRadius: '8px',
    overflow: 'hidden',
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});
